import React, { useContext, useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import DownloadIcon from "@mui/icons-material/Download";
import DonutSmallIcon from "@mui/icons-material/DonutSmall";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import ArrowBackIcon from "@mui/icons-material/ArrowBack"; // Import ArrowBackIcon
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf"; // Import PictureAsPdfIcon
import { Icon } from '@fluentui/react/lib/Icon';
import { getFileTypeIconProps } from '@fluentui/react-file-type-icons';
import { initializeFileTypeIcons } from "@fluentui/react-file-type-icons";
import ExcelJS from "exceljs";
import saveAs from "file-saver";
import { Grid, TextField, Paper, IconButton, Checkbox, FormControlLabel, FormGroup, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow   } from "@mui/material";
import { Dialog, Bar, TextArea } from '@ui5/webcomponents-react';
import OCRContext from "../../context/ocr-context";
import { MessageStrip } from '@ui5/webcomponents-react';
import { useStyles } from "./styles";
import ButtonContained from "../StyledComponents/ButtonContained";
import ButtonOutlined from "../StyledComponents/ButtonOutlined";
import InvoiceDataTable from "./InvoiceDataTable/InvoiceDataTable";
import SignatureTable from "./SignatureTable/SignatureTable";

import httpRequest from "../../httpRequest";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { isEmpty } from "lodash";
import AttachmentTable from "./AttachmentTable/AttachmentTable";
import UserContext from "../../context/user-context";
import ButtonNegative from "../StyledComponents/ButtonNegative";


initializeFileTypeIcons();

const cv = window.cv;


const SummaryCard = (props) => {
  const classes = useStyles();
  const ocrCtx = useContext(OCRContext);
  const userCtx = useContext(UserContext);
    const [supplierInfo, setSupplierInfo] = useState(null);
  const [isInvoice, setIsInvoice] = useState(false);
  const [dataChanged, setDataChanged] = useState(false);
  const [showRejectConfirmation, setShowRejectConfirmation] = useState(false);

   const [rejectReason, setRejectReason] = useState('');
   const [hierarchies, setHierarchies] = useState([]);

  const [initialData, setInitialData] = useState({});
  const [base64Image, setBase64Image] = useState("");
  const [pdfBase64, setPdfBase64] = useState('');
  const [imageBase64, setImageBase64] = useState('');
  const [newData, setNewData] = useState({});
  const [openExportDialog, setOpenExportDialog] = useState(false);
  const [exportSections, setExportSections] = useState({
    invoiceData: true,
    products: true,
    sellerDetails: true
  });
  const { enqueueSnackbar } = useSnackbar();
  const PDFJS = require("pdfjs-dist/webpack");
  
   
  const location = useLocation();
    const navigate = useNavigate();

  
const handleExit = () => {

  if (location.pathname === '/history' || location.pathname === '/my-invoices') {

    props.onBackButtonClick(); // Call the callback function passed from the parent
  } else {
      navigate('/my-invoices');
   
  }
};
  useEffect(() => {
    setIsInvoice(ocrCtx.isInvoice);
  }, []);

  useEffect(() => {
    setInitialData(props.dataFromDB ? props.dataFromDB : ocrCtx.extractedData);
  }, [props.dataFromDB, ocrCtx.extractedData]);
  
  
  const fetchVendorInfo = async () => {
    try {
      const vendorCode = props.dataFromDB ? props.dataFromDB.vendor_code : ocrCtx.vendorCode;
      const response = await httpRequest.get(`${process.env.REACT_APP_BACKEND_URL}/get-vendors`, {
        params: { vendor_code: vendorCode } // Passing vendor_code as a query parameter
      });
  
      // Assuming the backend returns a single vendor or null
      const foundVendor = response.data.vendor; // Adjust according to your backend response
      setSupplierInfo(foundVendor);
  
      console.log("Vendor code from props:", vendorCode);
      console.log("Vendor info:", foundVendor);
    } catch (error) {
      console.error("Error fetching vendor information:", error);
    }
  };
  


  useEffect(() => {
    fetchVendorInfo();
  }, []);


  

  useEffect(() => {
    const fetchInvoiceFiles = async () => {
      if (Object.keys(props).length !== 0) {
        try {
          const response = await httpRequest.get(`${process.env.REACT_APP_BACKEND_URL}/get-invoice-file?id=${props.dataFromDB.id}`);
          
          // Check if the response has the data
          if (response.data) {
            const { pdf_file, image_file } = response.data;

            // Set the base64 variables
            if (pdf_file) {
              setPdfBase64(pdf_file);
            }
            if (image_file) {
              setImageBase64(image_file);
            }
          }
        } catch (error) {
          console.error("Error fetching invoice files:", error);
        }
      }
    };

    fetchInvoiceFiles();
  }, [props]);


  const handleOpenFile = () => {
  // Check if props is empty and handle opening a file from the context
  if (Object.keys(props).length === 0) {
    openInPopup(ocrCtx.file);  // Ensure ocrCtx is defined in your context
  } else {
    // Open the PDF or image file in a popup if available
    if (pdfBase64) {
      openInPopup(convertBase64ToBlob(pdfBase64, "application/pdf"));
    } else if (imageBase64) {
      openInPopup(convertBase64ToBlob(imageBase64, "image/png"));
    }
  }
};

const openInPopup = (blob) => {
  const fileURL = URL.createObjectURL(blob);
  window.open(fileURL, "_blank", "height=800,width=600");
};


  const handleDownloadFile = async () => {
    const jsonData = JSON.parse(props.dataFromDB ? props.dataFromDB.parsed_data : ocrCtx.extractedData.parsed_data);
    const invoiceNumber = jsonData["Document Number"] || "invoice"; // Fallback if document number is missing

    if (Object.keys(props).length === 0) {
      downloadFile(ocrCtx.file, "file." + ocrCtx.file.type.split("/")[1]);
    }

    
    if (pdfBase64) {
      downloadFile(convertBase64ToBlob(pdfBase64, "application/pdf"), `${invoiceNumber}.pdf`);
    } else if (imageBase64) {
      downloadFile(convertBase64ToBlob(imageBase64, "image/png"), `${invoiceNumber}.png`);
    }
  };
  
const handleConvertToDocx = async () => {
  // Ensure pdfBase64 is available before trying to convert
  if (!pdfBase64) {
    enqueueSnackbar("No PDF file available to convert", { variant: "error" });
    return;
  }

  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/convert/pdf-to-docx`, {
      method: "POST",
      body: JSON.stringify({ pdfBase64 }), // Send the PDF Base64 data
      headers: {
        "Content-Type": "application/json"
      }
    });

    if (response.ok) {
      const blob = await response.blob(); // Get the blob response
      const jsonData = JSON.parse(props.dataFromDB ? props.dataFromDB.parsed_data : ocrCtx.extractedData.parsed_data);
      const invoiceNumber = jsonData["Document Number"] || "invoice"; // Fallback if document number is missing
      saveAs(blob, `${invoiceNumber}.docx`); // Use file-saver to download the converted file
    } else {
      enqueueSnackbar("Error converting PDF to DOCX", { variant: "error" });
    }
  } catch (error) {
    console.error("Error converting PDF to DOCX:", error);
    enqueueSnackbar("Error converting PDF to DOCX", { variant: "error" });
  }
};
  
const handleExportToExcel = async () => {
  try {
    const localData = props.dataFromDB ? props.dataFromDB.parsed_data : ocrCtx.extractedData.parsed_data;
	    console.log("localData:", localData); 


    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Invoice Data");

    if (exportSections.invoiceData) {
      // Add Invoice data to the worksheet
      const invoiceData = JSON.parse(localData);
      const invoiceFields = [
        { field: "Invoice Date", label: "Invoice Date" },
        { field: "Document Number", label: "Document Number" },
        { field: "Invoice Amount", label: "Invoice Amount" },
		{ field: "Tax Amount", label: "Tax Amount" },
        { field: "Due Date", label: "Due Date" },
        { field: "Currency", label: "Currency" },
        { field: "Payment Terms", label: "Payment Terms" },
        { field: "Purchase Order Number", label: "P.O. Number" },
      ];
      invoiceFields.forEach((field) => worksheet.addRow([field.label, invoiceData[field.field]]));
    }


if (exportSections.products && localData && localData) {
    const productsData = JSON.parse(localData);
    const lineItems = productsData.Items;
   
    if (lineItems && lineItems.length > 0) {
        worksheet.addRow([]); // Add an empty row for separation
        worksheet.addRow(["Line Items"]);
        worksheet.addRow([]); // Add an empty row for better readability
        worksheet.addRow(["Item Number", "Material Number", "Material Description", "Delivery Note Number", "Quantity", "Unit of Measure", "Price", "Total Amount", "Tax Amount", "Net Amount"]); // Header row
        lineItems.forEach((item) => {
            worksheet.addRow([
                item["Item Number"],
                item["Material Number"],
                item["Material Description"],
                item["Delivery Note Number"],
                item["Quantity"],
                item["Unit of Measure"],
                item["Price"],
                item["Total Amount"],
                item["Tax Amount"],
                item["Net Amount"]
            ]);
        });

           } else {
        console.error("Line items data is empty");
    }
} else {
    console.error("Export section for products is disabled or lineItems data is missing");
}

if (exportSections.sellerDetails) {
  // Define the desired order of fields
  const fieldOrder = ["vendor_code", "vendor_name", "vendor_address", "vendor_contact", "bank_name", "account_number", "iban_no"];
  
  // Add Seller data to the worksheet
  worksheet.addRow(["", ""]); // Add a blank row for separation
  worksheet.addRow(["Vendor Details"]);
    worksheet.addRow([]); // Add an empty row for better readability
  // Iterate over the fieldOrder array and add the corresponding data to the worksheet
  fieldOrder.forEach((field) => {
    // Check if the field exists in supplierInfo before adding it to the worksheet
    if (supplierInfo && supplierInfo[field]) {
      worksheet.addRow([field, supplierInfo[field]]);
    }
  });
}


      // Create a Blob containing the Excel file
      const blob = await workbook.xlsx.writeBuffer();

     // Save the Blob as an Excel file
saveAs(new Blob([blob], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), `${Object.keys(props).length === 0 && ocrCtx.invoiceNumber ? ocrCtx.invoiceNumber : props.dataFromDB ? JSON.parse(props.dataFromDB.parsed_data)["Document Number"] : ocrCtx.invoiceNumber}.xlsx`);

    } catch (error) {
      console.error("Error exporting to Excel:", error);
      enqueueSnackbar("Error exporting to Excel", { variant: "error" });
    }
  };

  const handleExportDialogOpen = () => {
    setOpenExportDialog(true);
  };

  const handleExportDialogClose = () => {
    setOpenExportDialog(false);
  };

  const handleExportSectionChange = (section) => (event) => {
    setExportSections({ ...exportSections, [section]: event.target.checked });
  };


  const convertBase64ToBlob = (base64, type) => {
    const byteCharacters = atob(base64);
    const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type });
  };

  const downloadFile = (file, fileName) => {
    const url = URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    link.click();
    setTimeout(() => {
      URL.revokeObjectURL(url);
    }, 100);
  };

  const openFile = (file) => {
    const url = URL.createObjectURL(file);
    window.open(url, "_blank");
    setTimeout(() => {
      URL.revokeObjectURL(url);
    }, 100);
  };


const handleDataChange = (updatedData, updatedVendor) => {
  setNewData({ ...newData, parsed_data: updatedData, vendor_code: updatedVendor });
  if (JSON.stringify(updatedData) !== JSON.stringify(initialData)) {
    setDataChanged(true);
  } else {
    setDataChanged(false);
  }
};


  const handleSave = async () => {
    try {
     
      
        newData.id = props.dataFromDB ? props.dataFromDB.id : ocrCtx.invoiceId;
      

      await httpRequest.post(`${process.env.REACT_APP_BACKEND_URL}/update-invoice/${newData.id}`, {
        new_data: newData,
      });

      enqueueSnackbar("Invoice updated successfully", { variant: "success" });

      setDataChanged(false);

    } catch (error) {
      console.error("Error updating invoice:", error);
    }
  };


  const handleReject = () => {

    setShowRejectConfirmation(true);
  };

  const handleRejectConfirm = async () => {
    try {
      let newData = {
        id: props.dataFromDB ? props.dataFromDB.id : ocrCtx.invoiceId,
        reject_reason: rejectReason,
        rejected_by: userCtx.employeeCode
      };

      console.log(newData);

      await httpRequest.post(`${process.env.REACT_APP_BACKEND_URL}/reject-invoice/${newData.id}`, {
        new_data: newData,
      });

      enqueueSnackbar("Invoice rejected successfully", { variant: "success" });

      setDataChanged(false);
      setShowRejectConfirmation(false); // Close the dialog after successful rejection
	  handleExit();
    } catch (error) {
      console.error("Error updating invoice:", error);
      enqueueSnackbar("Failed to reject invoice", { variant: "error" });
    }
  };

  const handleRejectCancel = () => {
    setShowRejectConfirmation(false);
  };

  const handleRelease = async (invoiceId) => {
    try {
        if (dataChanged) {
      enqueueSnackbar("Please save your changes before proceeding", { variant: "info" });
      return;
    }

  
  
      // Include user_id in the release request payload
      const payload = {
        user_id: userCtx.userId,
      };
  
      console.log(payload);
  
      // Proceed with releasing
      await httpRequest.post(`${process.env.REACT_APP_BACKEND_URL}/release-invoice/${invoiceId}`, payload);
      enqueueSnackbar("Invoice released successfully", { variant: "success" });
      handleExit();
    } catch (error) {
      console.error("Error releasing invoice:", error);
    }
  };
  



// Determine if the reject button should be disabled based on user permissions and invoice status
const isRejectDisabled = props.dataFromDB?.status === 'Approved' || props.dataFromDB?.status === 'Pending' || props.dataFromDB?.is_rejected;
const canRenderSaveButton =  props.dataFromDB ? props.dataFromDB.status === 'Pending' : ocrCtx.invoiceId;


 // Determine if the reject button should be shown
 const showRejectButton = !(
  (props.dataFromDB && props.dataFromDB.employee_code === userCtx.employeeData.employee_code) ||
  location.pathname === '/scan'
) && !isRejectDisabled;

const getButtonState = () => {
  const invoice = props.dataFromDB || {};
  const employeeData = userCtx.employeeData || {};

   // Always enable Release button on '/scan' path
   if (location.pathname === '/scan') {
    return { text: 'Release', disabled: false };
  }


  // Condition 4: Overall invoice status is Approved
  if (invoice.status === 'Approved') {
    return { text: 'Approved', disabled: true };
  }

  // Check if current user is last in the hierarchy array
  const isLastInHierarchy = () => {
    const hierarchy = hierarchies.find(h => h.position_id === (invoice.id || ocrCtx.invoiceId));
    return hierarchy && 
           hierarchy.hierarchy_positions[hierarchy.hierarchy_positions.length - 1] === employeeData.position_id;
  };

  // Condition 1
  if (invoice.employee_code === employeeData.employee_code) {
    if (invoice.standing_employee_code === null) {
      return { text: isLastInHierarchy() ? 'Approve' : 'Release', disabled: false };
    } else {
      return { text: 'Released', disabled: true };
    }
  }

  // Condition 2
  if (invoice.standing_employee_code === employeeData.employee_code) {
    return { text: isLastInHierarchy() ? 'Approve' : 'Release', disabled: false };
  }

  // Condition 3
  if (Array.isArray(invoice.approval_flow) && 
      invoice.approval_flow.some(flow => flow.includes(userCtx.userId)) &&
      invoice.standing_employee_code !== employeeData.employee_code) {
    return { text: 'Released', disabled: true };
  }

  // Default state if no conditions are met
  return { text: 'Release', disabled: true };
};

const buttonState = getButtonState();
  return (
    <>
	  
	  
	  
	  
	  
      <div className={classes.rootContainer}>
        
            <div className={classes.bar}>
              <div className={classes.save}>
{(location.pathname === "/history" || location.pathname === "/my-invoices") && (

			  <IconButton sx={{ padding: { xs: "3px", sm: "10px" } }} onClick={handleExit}>
                  <ArrowBackIcon  fontSize="large" sx={{ color: "#354a5f" }}/>
                </IconButton>  )}
				

				<div style={{ marginTop: "4%" }}>

        <ButtonContained
              style={{ marginLeft: "10px" }}
              onClick={() => handleRelease(props.dataFromDB ? props.dataFromDB.id : ocrCtx.invoiceId)}
              {...(buttonState.disabled ? { disabled: true } : {})}
            >
              {buttonState.text}
            </ButtonContained>

    {showRejectButton && (
      <ButtonNegative
        style={{ marginLeft: "10px" }}
        onClick={handleReject}
      >
        {props.dataFromDB?.is_rejected ? "Rejected" : "Reject"}
      </ButtonNegative>
    )}

{canRenderSaveButton && (
  <ButtonOutlined
    style={{ marginLeft: "10px" }}
    {...(!dataChanged ? { disabled: true } : {})}
    onClick={handleSave}
  >
    Save
  </ButtonOutlined>
)}

	  
	  
</div>

              </div>
			  
              <div className={classes.buttons}>

                <IconButton
                  sx={{ padding: { xs: "3px", sm: "10px" } }}
                  onClick={handleDownloadFile}
                >
                  <DownloadIcon fontSize="large" sx={{ color: "#354a5f" }} />
                </IconButton>
                <IconButton
                  sx={{ padding: { xs: "3px", sm: "10px" } }}
                  onClick={handleOpenFile}
                >
                  <OpenInNewIcon fontSize="large" sx={{ color: "#354a5f" }} />
                </IconButton>
				
  <IconButton
    sx={{ padding: { xs: "3px", sm: "10px" } }}
    onClick={handleExportDialogOpen}
  >
    <Icon {...getFileTypeIconProps({ extension: "xlsx", size: 48 })} />
  </IconButton>


  {props.dataFromDB && props.dataFromDB.filetype === "pdf" && (
  <IconButton
    sx={{ padding: { xs: "3px", sm: "10px" } }}
    onClick={handleConvertToDocx}
  >
    <Icon {...getFileTypeIconProps({ extension: "docx", size: 48 })} />
  </IconButton>
)}

              </div>
            </div>
            

              
              {props.dataFromDB || isInvoice ? (
                
                  <div className={classes.tables}>
				  
  <div className={classes.tableContainer}>
<div style={{ width: '50%', margin: '0 auto' }}>
  {props.dataFromDB && props.dataFromDB.is_rejected && (
    <MessageStrip
      design="Negative"
      hideCloseButton
      onClose={() => {}}
    >
      {props.dataFromDB.reject_reason}
    </MessageStrip>
  )}
</div>

<div style={{ position: 'relative', marginTop: 10 }}>


  <InvoiceDataTable
    data={props.dataFromDB ? props.dataFromDB.parsed_data : ocrCtx.extractedData.parsed_data}
	vendorCode={props.dataFromDB ? props.dataFromDB.vendor_code : ocrCtx.vendorCode}
  rawVendorData={ocrCtx && ocrCtx.rawVendorData ? ocrCtx.rawVendorData.vendor_data :  undefined}
    onDataChange={handleDataChange}
    previewMode={props.dataFromDB && props.dataFromDB.status !== 'Pending'}
  />
  
  {props.dataFromDB && props.dataFromDB.approval_flow.length > 0 && (
        <SignatureTable dataFromDB={props.dataFromDB} />
      )}

            <AttachmentTable invoiceId={props.dataFromDB ? props.dataFromDB.id : ocrCtx.invoiceId} companyId={props.dataFromDB ? props.dataFromDB.company_id : ocrCtx.companyId} functionId={props.dataFromDB ? props.dataFromDB.function_id : ocrCtx.functionId} userId={userCtx.userId} />
          
  
</div>

   
  </div>
</div>

                
              ) : (

                  <Paper
                    elevation={3}
                    sx={{ ml: 15, mr: 15, p: 10, borderRadius: 5, height: 100 }}
                  >
                    <h4 style={{ textAlign: "center", marginTop: "-15px" }}>
                      The recognized document is probably not an invoice. Please try again.
                    </h4>
                  </Paper>

              )}
      </div>
      <Dialog open={openExportDialog} onAfterClose={handleExportDialogClose} headerText={`Select Data Sections to Export`} style={{ zIndex: 1300 }} footer={
          <Bar design="Footer" endContent={
            <>
              <ButtonOutlined style={{ marginRight: 5 }} onClick={handleExportDialogClose}>Cancel</ButtonOutlined>
              <ButtonContained onClick={handleExportToExcel} design="Emphasized">
                Export
              </ButtonContained>
            </>
          } />
        }>

          <FormGroup>
            <FormControlLabel
              control={<Checkbox checked={exportSections.invoiceData} onChange={handleExportSectionChange('invoiceData')} />}
              label="Invoice Header"
            />
            <FormControlLabel
              control={<Checkbox checked={exportSections.products} onChange={handleExportSectionChange('products')} />}
              label="Line Items"
            />
            <FormControlLabel
              control={<Checkbox checked={exportSections.sellerDetails} onChange={handleExportSectionChange('sellerDetails')} />}
              label="Vendor Details"
            />
           
          </FormGroup>


      </Dialog>
	  
      <Dialog open={showRejectConfirmation} onAfterClose={handleRejectCancel} headerText={`Reject Invoice`}  footer={
  <Bar design="Footer" endContent={
    <>
      <ButtonOutlined style={{ marginRight: 5 }} onClick={handleRejectCancel}>Cancel</ButtonOutlined>
      <ButtonContained onClick={handleRejectConfirm} design="Emphasized">
        Reject
      </ButtonContained>
    </>
  } />
}>
  <TextArea
    autoFocus
    placeholder="Reason for rejection"
    rows={4}
    style={{ width: "100%" }}
    value={rejectReason}
    onChange={(e) => setRejectReason(e.target.value)}
  />
</Dialog>

    </>
  );
};

export default SummaryCard;
